import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Table } from 'antd';
import { getConsignmentOrderBillingsById } from '../../../../appRedux/actions';
import { stringDate } from '../../../../util';
import { ConsignOrderBillingStatus } from '../ConsignmentOrderBillingStatus';
import { consignmentOrderBillingModalConst } from '../../../../constants/ConsignOrderBilling.const';
import { formatPrice } from '../../../../util/formatPrice';

export const ConsignOrderModalBillgBody = ({ data = {} }) => {
  const dispatch = useDispatch();

  const { consignmentOrderBillingById } = useSelector(
    (state) => state.consignmentOrderBilling
  );

  useEffect(() => {
    if (data.id) {
      dispatch(getConsignmentOrderBillingsById(data.id));
    }
  }, [data.id, dispatch]);

  const billing = consignmentOrderBillingById;

  const order = billing?.consignmentOrder;
  const orderProducts = order?.consignmentOrderProduct || [];
  const billingProducts = billing?.consignmentOrderBillingProduct || [];

  const billedMap = billingProducts.reduce((acc, bp) => {
    const orderProductId = bp.consignmentOrderProduct?.id;
    if (!orderProductId) return acc;

    acc[orderProductId] = (acc[orderProductId] || 0) + bp.quantity;

    return acc;
  }, {});

  const consignmentOrderProducts = orderProducts.map((op) => ({
    id: op.id,
    nameProduct: op.product?.name ?? '-',
    quantityProduct: op.quantity ?? 0,
    totalBilled: billedMap[op.id] ?? 0,
  }));

  const columns = [
    {
      title: 'Nombre de producto',
      dataIndex: 'nameProduct',
      key: 'nameProduct',
    },
    {
      title: 'Cant. Recibida',
      dataIndex: 'quantityProduct',
      key: 'quantityProduct',
      render: (value) => value || 0,
    },
    {
      title: 'Cant. Facturada',
      dataIndex: 'totalBilled',
      key: 'totalBilled',
      render: (value) => value || 0,
    },
  ];

  return (
    <>
      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderBillingModalConst.payMethod}</h4>
        </Col>
        <Col span={16}>{billing?.payMethod}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderBillingModalConst.billingStatus}</h4>
        </Col>
        <Col span={16}>
          <ConsignOrderBillingStatus status={billing?.status} />
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderBillingModalConst.paidAt}</h4>
        </Col>
        <Col span={16}>
          {billing?.paidAt
            ? stringDate(billing.paidAt)
            : consignmentOrderBillingModalConst.noData}
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderBillingModalConst.total}</h4>
        </Col>
        <Col span={16}>{formatPrice(billing?.total)}</Col>
      </Row>

      <br />

      <Table
        dataSource={consignmentOrderProducts}
        columns={columns}
        rowKey="id"
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 40, 60],
        }}
      />
    </>
  );
};
